import { isEmpty } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { ExternalContent } from '../../../../../types/__codegen__/sanity/graphql';
import { WithOrderIndex } from '../types';

const mapExternalContent = ({ cmsSectionContent }: { cmsSectionContent: WithOrderIndex<ExternalContent> }) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }

  const mappedCmsContent = {
    identifier: cmsSectionContent.identifier?.current,
    orderIndex: cmsSectionContent.orderIndex,
    title: cmsSectionContent.title,
    type: CONTENT_SECTIONS.EXTERNAL_CONTENT,
  };

  return mappedCmsContent;
};

export default mapExternalContent;
